export const TODAY = 'TODAY';
export const THIS_WEEK = 'THIS_WEEK';
export const CUSTOM = 'CUSTOM';

export const DATE_RANGES = [
  {
    name: TODAY,
    label: 'Today',
  },
  {
    name: THIS_WEEK,
    label: 'This Week',
  },
  {
    name: CUSTOM,
    label: 'Custom',
  },
];
